/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Component imports */

/* Style imports */
import "./styles.css"

/*** End Imports ***/

const Gutter = (props)=>{

    return(
        <div className="normal-gutter" style={{height : props.height, width : props.width}}>
        </div>
    );
};

Gutter.propTypes = {
    height : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width : PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Gutter.defaultProps = {
    height : "100%",
    width : "100%",
};


export default Gutter;


// WEBPACK FOOTER //
// ./src/components/Gutter/Gutter.js